$(document).ready(function(){

    // funzione custom drawer per taglie
    $('.open-custom-drawer').on('click',function(e){
        $('#PageCustomDrawer').css('right', 0);
    });

    $('.drawer__close').on('click', function (e){
        $('#PageCustomDrawer').css('right', '-100%');
    })




    // funzione accordion
    $('.open-custom-drawer').click(function(){
        $("body").css("overflow", "hidden");
    })
    $('.drawer__close-button').click(function(){
        $("body").css("overflow", "auto");
    })



    $('.box_accordion .hide').hide();
    
    $('.box_accordion .title').click(function(){
        var display = ($(this).parent().find('.hide').css("display"));
        
        $('.hide').slideUp();
        $('.title').removeClass('special');
        if(display == "none"){
            $(this).parent().find('.hide').slideDown();
            $(this).addClass('special');
        }
        else{
            $(this).parent().find('.hide').slideUp();
            $(this).removeClass('special');
        }
    });
})